<template lang="pug">
	.radio-schedule
		.widgets-area.segment
			.widgets-col
				.widget
					.header.label {{$tCaption('Upload radio schedule (.xml)')}}
					.data-vertical
						FileUploader(
							:multiple="false",
							:allowed-file-extensions="['.xml']",
							upload-mode="useForm",
							@value-changed="fileChanged"
						)
		.widgets-area.segment(v-if="data.radioScheduleFile")
			.widgets-col
				.widgets-row
					.widget
						.header.label {{$tCaption('Spots')}}
						.data-statistic
							span {{totals.spots}}
					.widget
						.header.label {{$tCaption('Cost')}}
						.data-statistic
							span {{formatNumber(totals.cost)}}
				.widget
					.header.label {{$tCaption('Select radio')}}
					.data-vertical
						ProductSelectionComponent(:items="radios", :selectedValues="data.radios")
							template(v-slot:card="{ data }")
								.flex-col.justify.space-large.full-height
									.spacer
									.font-large {{data.name}}
									.flex-row.justify
										span ${{data.cost}}
										span {{data.spots}} {{$tCaption('spots')}}

</template>

<script>
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import FileUploader from 'devextreme-vue/file-uploader';
	import ProductSelectionComponent from './ProductSelectionComponent.vue';
	import Localization from 'devextreme/localization.js';
	import Data from 'app-core/Data';

	export default {
		translationCategory: 'proposal.RadioSchedule',
		name: 'radio-schedule',
		components: {
			FileUploader,
			ProductSelectionComponent
		},
		props: {
			data: VueTypes.object.def({})
		},
		data() {
			return {
				radios: []
			};
		},
		computed: {
			totals() {
				return this.radios.filter(f => this.data.radios.indexOf(f.oid) > -1).reduce((total, f) => ({ spots: total.spots + f.spots, cost: total.cost + f.cost }), { spots: 0, cost: 0 });
			}
		},
		watch: {
			'data.radios'() {
				this.data.radioSpots = this.totals.spots;
				this.data.radioCost = this.totals.cost;
			}
		},
		mounted() {
			if (__DEBUG__)
				console.log('Radio schedule mounted', this);
		},
		methods: {
			fileChanged(v) {
				if (v.value && v.value.length) {
					var reader = new FileReader();
					reader.onload = () => {
						this.data.radioScheduleFile = reader.result;
						this.processScheduleFile(reader.result);
					};
					reader.readAsText(v.value[0]);
				} else
					this.data.radioScheduleFile = null;
			},
			formatNumber(num) {
				return Localization.formatNumber(num, {
					type: 'currency',
					precision: 0
				});
			},
			processScheduleFile(data) {
				let xmlDoc = null;
				if (window.DOMParser)
				{
					let parser = new window.DOMParser();
					xmlDoc = parser.parseFromString(data, 'text/xml');
				}
				else // Internet Explorer
				{
					xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
					xmlDoc.async = false;
					xmlDoc.loadXML(data);
				}

				const xmlJson = Data.xmlToJson(xmlDoc);
				this.data.radioSpots = 0;
				this.data.radioCost = 0;
				this.data.radios = [];

				this.radios = [];

				const orders = Array.isArray(xmlJson.Transmission.Transaction.Campaign.Order) ? xmlJson.Transmission.Transaction.Campaign.Order : [xmlJson.Transmission.Transaction.Campaign.Order];
				orders.map(order => {
					const stationOrders = Array.isArray(order.StationOrder) ? order.StationOrder : [order.StationOrder];
					stationOrders.map(stationOrder => {
						const station = stationOrder.Station;
						const spotQuantity = _.sumBy(stationOrder.BuyLine, bl => _.sumBy(bl.AirPeriod, (v) => parseFloat(v.SpotQuantity) || 0) || 0);
						const budget = _.sumBy(stationOrder.BuyLine, bl => _.sumBy(bl.AirPeriod, (v) => parseFloat(v.SpotQuantity) * parseFloat(v.UnitRate) || 0) || 0);
						const stationName = `${station.StationName} ${station.Band}`;

						let existsRadio = _.find(this.radios, (r) => r.oid === stationName);
						if (!existsRadio) {
							this.radios.push({ oid: stationName, name: stationName, logo: null, spots: spotQuantity, cost: budget });
						} else {
							existsRadio.spots = (existsRadio.spots || 0) + (spotQuantity || 0);
							existsRadio.cost = (existsRadio.cost || 0) + (budget || 0);
						}
					});
				});

				this.data.radios = this.radios.map(f => f.oid);
			}
		}
	};
</script>
<style lang='scss'>
	.radio-schedule {

	}
</style>
